import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, ElementRef } from '@angular/core';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { FormService } from './form.service';
import { FormData } from './classes/data';
import { FormSchema } from './classes/schema';

import { FormSchemaData, FormSubmitEvent } from './form.interface';

/**
 * Renderiza uma instÃ¢ncia do formulÃ¡rio no HTML
 *
 * @example
 * <uex-form [form]="form"></uex-form>
 */
@Component({
  selector: 'uex-form',
  templateUrl: './form.component.html'
})
export class FormComponent implements OnChanges, OnDestroy {

  @Input('schema') schema: Array<FormSchemaData>;
  @Input('form')
    public set form(form: FormData) {
      this._form = form;
      if (this._submit_subscription) { this._submit_subscription.unsubscribe(); }
      if (!this._form) { return; }

      if (this.schema && !this.form) { this.form = this._formService.create(this.schema); }
      this._submit_subscription = this.form.$onSendSubmit.subscribe(() => this.submit());
    }
    public get form(): FormData {
      return this._form;
    }
  @Input('skinny') skinny: any;

  @Output('uexSubmit') uexSubmit: EventEmitter<FormSubmitEvent> = new EventEmitter();

  /**
   * @ignore
   */
  constructor(
    private _formService: FormService,
    public elementRef: ElementRef
  ) { }

  private _submit_subscription: Subscription;
  private _form: FormData;

  public ngOnChanges() {
    if (this.skinny == '') { this.skinny = true; }
  }

  public ngOnDestroy() {
    if (this._submit_subscription) { this._submit_subscription.unsubscribe(); }
  }

  /**
   * DistÃ¢ncia do elemento para o topo do elemento pai mais prÃ³ximo posicionado com relative
   */
  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  /**
   * Emite o evento submit do formulÃ¡rio
   */
  public submit() {
    this.onSubmit();
  }

  /**
   * @internal
   */
  public onSubmit() {
    if (this.form.locked) { return; }
    const valid = this.form.validate(true);

    const event: FormSubmitEvent = {
      data: this.form.value,
      valid: this.form.valid,
      errors: this.form.errors
    };

    if (this.form.submitHandler) {
      if (valid) { this.form.lock(); }
      this.form.submitHandler(event, () => {
        if (valid) { this.form.unlock(); }
      });
    }

    this.form.onSubmit.emit(event);
    this.uexSubmit.emit(event);
  }

  /**
   * @internal
   */
  public trackBySchemaFn(index: number, schema: FormSchema): any {
    return schema.key || index;
  }

  /**
   * @internal
   */
  public hasLabels(): boolean {
    return this.form ? this.form.hasLabels() : true;
  }

}
